// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f9387755","453":"183908db","732":"141da999","977":"ce1bd7ff"}[chunkId] + ".chunk.js";
};